// Centered empty state: one-line title + optional description + optional action.
const EmptyState = ({ title, description, action }) => (
  <div className="rounded-md border border-dashed border-border/60 px-6 py-12 text-center">
    <p className="text-sm font-medium">{title}</p>
    {description && <p className="mt-1 text-sm text-muted-foreground">{description}</p>}
    {action && <div className="mt-4 flex justify-center">{action}</div>}
  </div>
);

export default EmptyState;
